import { useQuery } from 'react-query';
import axios from '../axios';
import { map } from 'lodash-es';
import { sortByMonth, sortByMonthAndYear } from '../misc';
import dateToMonth, { dateToMonthYear } from '../dateToMonth';
import moment from 'moment';

export function usePlanList() {
  return useQuery('customer/plan', () =>
    axios.get('/users/plan').then((res) => res.data),
  );
}

export function useChargerList() {
  return useQuery('customer/charger', () =>
    axios.get('/users/charger').then((res) => res.data),
  );
}

export function useChargerDetails(id) {
  return useQuery(['customer/charger', id], ({ queryKey }) => {
    const [, id] = queryKey;
    return axios.get(`/users/charger/${id}`).then((res) => {
      return res.data;
    });
  });
}

export function usePlanDetails(id) {
  return useQuery(['customer/plan', id], ({ queryKey }) => {
    const [, id] = queryKey;
    return axios.get(`/users/plan/${id}`).then((res) => res.data);
  });
}

export function useWalletTransactionList() {
  return useQuery('customer/walletTransection', () =>
    axios.get('/users/getWalletTransection').then((res) => res.data),
  );
}

export function useWalletDetails() {
  return useQuery('customer/wallet', () =>
    axios.get('/users/wallet').then((res) => res.data),
  );
}

export function useCustomerOrderList(days = false) {
  return useQuery('customer/order', () =>
    axios.get('/users/order').then((res) => {
      return res.data;
    }),
  );
}

export function useCustomerOrderByDateList(days = 10) {
  return useQuery(`customer/order?status=PAID&days=${days}`, () =>
    axios.get('/users/order').then((res) => {
      return res.data;
    }),
  );
}

export function useCustomerOrderDetails(id) {
  return useQuery(['customer/order', id], ({ queryKey }) => {
    const [, id] = queryKey;
    return axios.get(`/users/order/${id}`).then((res) => res.data);
  });
}

export function useCustomerSessionsListForMap() {
  return useQuery('customer/customerSessionForMap', () =>
    axios.get('/users/customerSession').then((res) => res.data),
  );
}

export function useCustomerSessionList({
  limit = 2,
  offset = 0,
  startDate = '',
  endDate = '',
}) {
  return useQuery(
    ['customer/customerSession', limit, offset, startDate, endDate],
    ({ queryKey }) => {
      const [, limit, offset, startDate, endDate] = queryKey;
      const params = {
        limit,
        offset,
        startDate: moment(startDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
        endDate: moment(endDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
      };
      return axios
        .get('/users/customerSessionWithPagination', {
          params,
        })
        .then((res) => {
          return res.data;
        });
    },
    {
      enabled: !!(startDate && endDate),
    },
  );
}

export function useCustomerSessionListExport({
  startDate = '',
  endDate = '',
  orderBy = '',
  sortOrder = '',
}) {
  return useQuery(
    ['customer/customerSessionExport', startDate, endDate, orderBy, sortOrder],
    ({ queryKey }) => {
      const [, startDate, endDate, orderBy, sortOrder] = queryKey;
      const params = {
        startDate: moment(startDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
        endDate: moment(endDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
        orderBy,
        sortOrder,
      };
      return axios
        .get('/users/customerChargingSessions/export', {
          params,
        })
        .then((res) => {
          return res.data;
        });
    },
    {
      enabled: !!(startDate && endDate),
    },
  );
}

export function useCustomerSessionDetails(id) {
  return useQuery(['customer/customerSession', id], ({ queryKey }) => {
    const [, id] = queryKey;
    return axios.get(`/users/customerSession/${id}`).then((res) => res.data);
  });
}

export function useChargingStatusList() {
  return useQuery('customer/chargingStatus', () =>
    axios.get('/users/chargingStatus').then((res) => res.data),
  );
}

export function useChargingStatusDetails(id) {
  return useQuery(['customer/chargingStatus', id], ({ queryKey }) => {
    const [, id] = queryKey;
    return axios.get(`/users/chargingStatus/${id}`).then((res) => res.data);
  });
}

export function useChargingStatusFromQueueDetails(id) {
  return useQuery(
    ['customer/getChargingStatusFromQueueId', id],
    ({ queryKey }) => {
      const [, id] = queryKey;
      return axios
        .get(`/users/getChargingStatusFromQueueId/${id}`)
        .then((res) => res.data);
    },
  );
}

export function useIdTagList() {
  return useQuery('customer/idTag', () =>
    axios.get('/users/idTag').then((res) => res.data),
  );
}

export function useCustomerSingleMetrics() {
  return useQuery('customer/singleMetrics', () =>
    axios.get('/users/singleMatricCustomer').then((res) => res.data),
  );
}

export function useCustomerGeneralAnalyticsByMonth() {
  return useQuery('Customer/generalCustomerAnalyticsbyMonth', () =>
    axios.get('/users/generalAnalytics?byGrouping=1').then((res) => {
      res.data = sortByMonthAndYear(res.data);
      map(res.data, (row, index) => {
        if (row.DATE.length === 7) {
          res.data[index].DATE = dateToMonthYear(row.DATE);
        }
      });
      return sortByMonth(res.data);
    }),
  );
}

export function useCustomerGeneralAnalyticsByYear() {
  return useQuery('Customer/generalCustomerAnalyticsbyYear', () =>
    axios.get('/users/generalAnalytics?byGrouping=2').then((res) => res.data),
  );
}

export function useGeneralCustomerAnalytics(limit = 10) {
  return useQuery(
    ['Customer/generalCustomerAnalytics', limit],
    ({ queryKey }) => {
      const [, limit] = queryKey;
      return axios.get(`/users/generalAnalytics?days=${limit}`).then((res) => {
        map(res.data, (row, index) => {
          if (row.DATE.length === 7) {
            res.data[index].DATE = dateToMonth(row.DATE);
          }
        });
        // return sortByDate(res.data);
        return res.data;
      });
    },
  );
}
